module.exports = __webpack_public_path__ + "img/vertical_6_2_0.8fc9e3d5.png";